import React from 'react';
import { Button, Card, CardActions } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { CheckCircle as CheckCircleIcon } from '@material-ui/icons';

import CardTitle from '../../../common/card/CardTitle';
import CardContent from '../../../common/card/CardContent';

export interface PurchaseOrderSubmitCardProps {
  onCancel?: () => void;
}

const PurchaseOrderSubmitCard: React.FC<PurchaseOrderSubmitCardProps> = (
  props: PurchaseOrderSubmitCardProps
) => {
  const { onCancel } = props;
  return (
    <Card>
      <CardTitle>
        <CheckCircleIcon />
        Submit Purchase Order
      </CardTitle>
      <CardContent>
        <Alert severity='info'>
          Submit the form for review once the fields are filled up to confirm
          Purchase Order.
        </Alert>
      </CardContent>
      <CardActions style={{ padding: '8px 16px 16px' }}>
        <Button fullWidth variant='outlined' onClick={onCancel}>
          Cancel
        </Button>
      </CardActions>
    </Card>
  );
};

export default PurchaseOrderSubmitCard;
